import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { finalize, Observable } from 'rxjs';
import { Bill } from 'src/app/models/bill';
import { Contest } from 'src/app/models/contest';
import { AuthService } from 'src/app/services/auth.service';
import { BillService } from 'src/app/services/bill.service';
import { PictureService } from 'src/app/services/picture.service';
import { ToolsService } from 'src/app/services/tools.service';
import { environment } from 'src/environments/environment';
import { ButtonsModalComponent } from '../buttons-modal/buttons-modal.component';
import { ConfigService } from 'src/app/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-upload-bill',
  templateUrl: './upload-bill.component.html',
  styleUrls: ['./upload-bill.component.scss'],
})
export class UploadBillComponent implements OnInit {
  @Input() selectedContest?: Contest;

  @Output() onContinue: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBack: EventEmitter<any> = new EventEmitter<Bill>();

  loading: boolean = false;

  images: Array<string> = [];
  loadingState$!: Observable<{
    loading: boolean;
    phrase: string;
    gif?: string;
  }>;

  adminToken: string | null = '';
  userId: number | null = null;
  isPqrsActive: any = false;
  buttonsList: any;

  titleText: string = '¿Te gustaría actualizar tus datos?';
  buttonText: string = 'Actualizar datos';

  rolesOptionsAllowed = false;

  constructor(
    private pictureService: PictureService,
    private billService: BillService,
    private toolsService: ToolsService,
    private authService: AuthService,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private configSvc: ConfigService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loadingState$ = this.toolsService.loadingState$;
    this.adminToken = this.billService.adminToken;
    this.loadUserId();
    this.isPqrsActive = this.configSvc.mall?.pqrs_active;

    this.route.queryParams.subscribe(params => {
      const role = params['role'];

      if (role == '63') {
        this.titleText = '¿Te gustaría actualizar los niños?';
        this.buttonText = 'Actualizar amiguitos';
      }
    });


    if (!this.adminToken) {
      this.route.queryParams.subscribe(params => {
        const role = params['role'];

        if (role === '63') {
          this.rolesOptionsAllowed = true;
          console.log('roles allowed?: ', this.rolesOptionsAllowed)
          this.getButtons();
        } else {
          this.rolesOptionsAllowed = false;
        }
      });
    }
  }

  goBack() {
    this.onBack.emit();
  }

  loadUserId() {
    if (!this.adminToken) return;
    this.authService.getUserInfo().subscribe((response) => {
      this.userId = response.id;
    });
  }

  goToUserDetail() {
    window.open(
      `${environment.adminUrl}/client-details/${this.userId}`,
      '_blank'
    );
  }

  async continue() {
    // console.log("valor del concurso ", this.selectedContest)
    this.loading = true;
    let recognizedBill = null;
    try {
      recognizedBill = await this.billService.analizeBillV2(this.selectedContest!, this.images[0]);
      // console.log(recognizedBill)
    } catch (error) {
      let errorMessage = "No se pudo reconocer la factura, por favor intente de nuevo más tarde";
      if (error == 'AZURE_OCR_ERROR') errorMessage = "[AZ-OCR] No se pudo reconocer la factura, por favor intente de nuevo más tarde";
      else if (error == 'BILL_SERVICE_ERROR') errorMessage = "[BS] No se pudo reconocer la factura, por favor intente de nuevo más tarde";
      this.toolsService.presentErrorToast(errorMessage);
      this.loading = false;
      return;
    }
    console.debug("recognizedBill", recognizedBill);
    this.loading = false;
    this.onContinue.emit({ bill: recognizedBill, images: this.images });
    this.modalCtrl.dismiss({ recognizedBill, images: this.images })
  }

  async validateBillInfo(recognizedBill: Bill) {
    // If the contest has validate_products set to true, we need to validate if at least one product was recognized as valid
    if (this.selectedContest?.validate_products) {
      let validProducts = recognizedBill.products.filter(
        (product) => product.is_valid
      );
      if (validProducts.length == 0) {
        return false;
      }
    }
    // If the contest has manual_validation set to false, all the mandatory fields must be filled
    if (!this.selectedContest?.manual_validation) {
      let billNumberRecognized = recognizedBill.billNumber != null;
      let dateRecognized = recognizedBill.date != null;
      let storeRecognized = recognizedBill.store != null;
      let totalRecognized = recognizedBill.total != null;
      if (
        !billNumberRecognized ||
        !dateRecognized ||
        !storeRecognized ||
        !totalRecognized
      ) {
        return false;
      }
    }
    return true;
  }

  async takePicture() {
    let imageSrc = await this.pictureService.takePicture();
    if (!imageSrc) return;
    this.images.push(imageSrc);
  }


  deleteImage(index: number) {
    this.images.splice(index, 1);
  }

  goToBillDetails() {
    const nextComponent = 'bill-detail';

    this.onContinue.emit({
      next: nextComponent,
    });
  }

  get canViewUserDetail() {
    // TODO check admin permissions
    return this.adminToken != null && this.userId != null;
  }

  async getButtons() {
    this.loading = true;

    this.authService.getButtonsRoles().pipe(finalize(() => (this.loading = false))).subscribe({
        next: (response) => {
          if (response.length > 0) {
            this.buttonsList = response;
            this.openModalButtons(response);
          }
        },
        error: (error) => {
          console.error('Error obteniendo los botones:', error);
        },
      });
  }

  async openModalButtons(buttons: any) {
    const modal = await this.modalCtrl.create({
      component: ButtonsModalComponent,
      componentProps: {
        buttons,
      },
      cssClass: 'custom-modal',
    });

    modal.onDidDismiss().then((resp) => {
      if (resp.data?.goToLogin) {
        this.toolsService.role = resp.data.role;
        this.toolsService.start = true;

        this.onBack.emit('login');
      }
    });

    await modal.present();
  }

  goToUpdateData() {
    this.router.navigate(['update-data'], { queryParamsHandling: 'preserve' });
  }

  goToPqrs(){
    this.router.navigate(['client-pqr'])
  }

}
